
import UserService from "@/services/auth/UserService";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({
  components: {
    AlertPainel,
  },
})
export default class AlertPainel extends Vue {
@Prop()
private loading;

@Prop()
private painel;

@Watch("loading", { immediate: false, deep: false })
onLoadingMetricChanged(val: any, oldVal: any) {
    if(this.painel){
        // const userService = new  UserService();
        // this.painelMessage = (userService.painelMessage() as any).body.find(e => e.type === 'alert');
        // console.log(this.painelMessage);
        
    }
}

// get url location to show info only at dashboard
private currentLocation = window.location.pathname;
private dismissInfoCountDown: number = 999;
private painelMessage:any;

  private async mounted() {
    // console.log(this.painelMessage);
  }
}
